import classNames from 'classnames';
import React from 'react';
import Slider, { Settings } from 'react-slick';
import { dispatchEvent } from './utils';
import { SliderProps } from './models';

export const GeSlider = ({ ...props }: SliderProps) => {
    const sliderRef = React.useRef() as React.RefObject<HTMLDivElement>;
    const classes = classNames(props?.className, props?.settings?.className, {
        'slick-slider--overlap': !!props.isOverlap,
    });

    const settings: Settings = {
        ...props.settings,
        afterChange: (currentSlideNumber: number) => {
            if (sliderRef.current) {
                setTimeout(() => {
                    dispatchEvent({ eventType: 'slidechange', element: sliderRef.current });
                }, 100);
            }

            if (props.settings.afterChange) {
                props.settings.afterChange(currentSlideNumber);
            }
        },
    };
    const extendedProps = {
        ...props,
        settings: { ...settings, className: classes },
    };

    return (
        <div ref={sliderRef}>
            <Slider {...extendedProps.settings} >
                {props.children}
            </Slider>
        </div>
    );
}